
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

// Display html from richText json
export default {
  props: {
    richText: {
      type: Object,
      required: true,
    },
    lightText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    html() {
      return documentToHtmlString(this.richText)
    },
  },
}
